import { render, staticRenderFns } from "./MovementSidebar.vue?vue&type=template&id=3d15a446&"
import script from "./MovementSidebar.vue?vue&type=script&lang=js&"
export * from "./MovementSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MovementSidebar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports